/** Default on so existing sessions without the flag keep current behavior. */
export const isAiBasedAnalysisEnabled = (user) => {
  if (user == null || user.ai_based_analysis_enabled == null || user.ai_based_analysis_enabled === '') {
    return true;
  }
  return Number(user.ai_based_analysis_enabled) !== 0;
};
